
import anim_img1 from "../assets/images/anim_img1.png"
import anim_img2 from "../assets/images/anim_img2.png"
import anim_img3 from "../assets/images/anim_img3.png"

export const animatedItems = [
  {
    img: anim_img1,
    number: "01",
    title: "Развитие",
    title_color: "карьеры",
    description:
            "Мы делимся инструментами поиска работы и развития карьеры, проводим консультации.",
    title_strong: "Вы получаете ответы на ваши вопросы:",
    answers: [
      "Куда и как развиваться дальше?",
      "Стоит ли менять работу?",
      "Как говорить о повышении?",
      "Стоит ли принимать новый оффер?",
    ],
  },
  {
    img: anim_img2,
    number: "02",
    title: "Работа",
    title_color: "с эмоциональным выгоранием",
    description:
            "Мы разберем откуда исходят низкая продуктивность, нежелание работать и страх не найти ничего лучше. Проведем диагностику ваших сильных сторон.",
    title_strong: "Вы получаете:",
    answers: [
      "Ответ как себя защитить от выгорания и преодолеть кризис в карьере",
      "Пошаговый план для личного и профессионального роста",
    ],
  },
  {
    img: anim_img3,
    number: "03",
    title: "Поиск",
    title_color: "работы",
    description:
            "Мы вводим поэтапно рабочие инструменты, которые помогут достичь вашей карьерной цели.",
    title_strong: "Решаем проблемы:",
    answers: [
      "Сложности с поиском",
      "Отказы на собеседованиях",
      "Страх говорить о себе",
      "Релокация",
      "Неэффективное резюме и профиль LinkedIn",
    ],
  },
];
